import React, { useEffect, useState, useRef } from "react";
import "../scss/_stage.scss";

const Stage = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(false);
  const stageRef = useRef(null);

  useEffect(() => {
    // Mobile detection
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768 || "ontouchstart" in window);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    const handleMouseMove = (e) => {
      if (!isMobile && stageRef.current) {
        const rect = stageRef.current.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        // Berechne relative Position zur Mitte des Elements
        const x = (e.clientX - centerX) / rect.width;
        const y = (e.clientY - centerY) / rect.height;

        // Begrenze die Werte und skaliere sie für den Parallax-Effekt
        const parallaxX = Math.max(-1, Math.min(1, x)) * 20; // Max 20px Bewegung
        const parallaxY = Math.max(-1, Math.min(1, y)) * 20; // Max 20px Bewegung

        setMousePosition({ x: parallaxX, y: parallaxY });
      }
    };

    const handleDeviceOrientation = (e) => {
      if (isMobile) {
        // DeviceOrientationEvent Werte:
        // beta: Neigung vor/zurück (-180 bis 180)
        // gamma: Neigung links/rechts (-90 bis 90)

        const beta = e.beta || 0; // Vor/zurück Neigung
        const gamma = e.gamma || 0; // Links/rechts Neigung

        // Normalisiere die Werte und skaliere sie
        // Beta: -30 bis 30 Grad als sinnvoller Bereich
        // Gamma: -30 bis 30 Grad als sinnvoller Bereich
        const normalizedX = Math.max(-1, Math.min(1, gamma / 30)) * 15; // Max 15px
        const normalizedY = Math.max(-1, Math.min(1, beta / 30)) * 15; // Max 15px

        setMousePosition({ x: normalizedX, y: normalizedY });
      }
    };

    const requestOrientationPermission = async () => {
      if (isMobile && typeof DeviceOrientationEvent !== "undefined") {
        // iOS 13+ benötigt explizite Erlaubnis
        if (typeof DeviceOrientationEvent.requestPermission === "function") {
          try {
            const permission = await DeviceOrientationEvent.requestPermission();
            if (permission === "granted") {
              window.addEventListener(
                "deviceorientation",
                handleDeviceOrientation
              );
            }
          } catch (error) {
            console.log("DeviceOrientation permission denied");
          }
        } else {
          // Andere Browser/Versionen
          window.addEventListener("deviceorientation", handleDeviceOrientation);
        }
      }
    };

    if (isMobile) {
      requestOrientationPermission();
    } else {
      window.addEventListener("mousemove", handleMouseMove);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("deviceorientation", handleDeviceOrientation);
      window.removeEventListener("resize", checkIsMobile);
    };
  }, [isMobile]);

  return (
    <section
      className="stage"
      ref={stageRef}
      style={{
        "--mouse-x": `${mousePosition.x}px`,
        "--mouse-y": `${mousePosition.y}px`,
      }}
    >
      <div className="stage--content-intro">
        Thank you for joining our <span className="symbol">mail</span> newsletter and <span className="symbol">share</span> sharing your Hans Zimmer Live experience. All winners <span className="symbol">diamond</span> will recive an email with further information.
      </div>

      <div className="stage--content">
        <div style={{maxWidth: "580px", marginLeft: "auto", marginRight: "auto"}}>
          <h2>Discover more:</h2>
          <p style={{fontSize: "1.4rem", marginBottom: "2.4rem", lineHeight: "1.4"}}>A symphonic journey curated by Hans Zimmer himself. On tour in 2026. Get your tickets now!</p>
          <a href="https://www.hanszimmerlive.com" target="_blank" rel="noopener noreferrer" className="buttonControl buttonControl--outlined">
            Get Tickets now!
          </a>
        </div>
      </div>
    </section>
  );
};

export default Stage;
